// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".background-for-icon[data-v-666bc742] {\n  background-color: #f0f0f0;\n  border-radius: 50%;\n  width: 250px;\n  height: 250px;\n}\n.DashboardBox[data-v-666bc742] {\n  padding-left: 5%;\n  padding-right: 5%;\n}\n.equipmentCard[data-v-666bc742] {\n  border-left: 10px solid #009ed5;\n}", ""]);
// Exports
module.exports = exports;
